import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {

	window.scrollTo(0, 0);
	
    return {
        type: 'PRE_INCUBACAO_IDEACAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PRE_INCUBACAO_IDEACAO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('preIncubacaoIdeacaoForm', registro)
    ];
}

export function getLista() {
	const request = axios.get(`${consts.API_URL}/preIncubacaoIdeacao`);
	return {
		type: 'PRE_INCUBACAO_IDEACAO_LISTADO',
		payload: request
	};
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/preIncubacaoIdeacao`, {
				...registro,
				id_usuario: getState().auth.usuario.id,
				investimento_inicial: FormatUtils.formatarValorBanco(registro.investimento_inicial, 2),
				faturamento_ultimo_trimestre: FormatUtils.formatarValorBanco(registro.faturamento_ultimo_trimestre, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/preIncubacaoIdeacao`, {
				...registro,
				investimento_inicial: FormatUtils.formatarValorBanco(registro.investimento_inicial, 2),
				faturamento_ultimo_trimestre: FormatUtils.formatarValorBanco(registro.faturamento_ultimo_trimestre, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/preIncubacaoIdeacao?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}